
import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr';
import * as CONFIG from '@/config/config'

export default {


    install (Vue) {
        const connection = new HubConnectionBuilder()
        .withUrl(CONFIG.CORE_URL + `/transfere/hub`)
        .configureLogging(LogLevel.Information)
        .build()

        const transfereHub = new Vue() // use new Vue instance as an event bus
        let HubConnectionState = "err";
        let startedPromise = null
            function start () {
            startedPromise = connection.start()
                .catch(err => {
                console.error('Failed to connect with hub', err)
                HubConnectionState = "err"
                transfereHub.$emit('HubConnectionStatus', { HubConnectionState })

                return new Promise((resolve, reject) => setTimeout(() => start().then(resolve).catch(reject), 5000))
                })
                HubConnectionState = "ok";
                transfereHub.$emit('HubConnectionStatus', { HubConnectionState })

            return startedPromise
            }
            connection.onclose(() => start())
            // Add the hub to the Vue prototype, so every component can listen to events or send new events using this.$questionHub
        Vue.prototype.$transfereHub = transfereHub
      

        connection.on('MyoidIDChanged', (id) => {
            transfereHub.$emit('MyoidIDChanged', { id })
          })
       
        start()
        },

}